import { useState } from "react"
import {
  AnnouncementsItemType,
  FeedbackSurvey
} from "../../../../../mp-database/contextHelpManager"
import { FACE_NAMES_WITH_NULL_VALUE } from "../../ExperienceRatingScale/constants"
import { ExperienceRating } from "../../ExperienceRatingScale/types"
const useFeedback = () => {
  const [feedbackShow, setFeedbackShow] = useState<boolean>(false)
  const [feedback, setFeedback] = useState<FeedbackSurvey>({
    id: "",
    rating: 0,
    feedback: ""
  })

  const checkFeedbackClose = (item: AnnouncementsItemType) => {
    if (item.type === "FEEDBACK_REQUEST") {
      setFeedback({
        id: item.id,
        rating: 0,
        feedback: ""
      })
      setFeedbackShow(false)
    }
  }

  const onFeedbackSmileClick = (rate: ExperienceRating) => {
    const rateIndex = FACE_NAMES_WITH_NULL_VALUE.indexOf(rate)
    setFeedback({
      ...feedback,
      rating: rateIndex
    })
    setFeedbackShow(true)
  }

  return {
    feedbackShow,
    feedback,
    setFeedback,
    checkFeedbackClose,
    onFeedbackSmileClick
  }
}

export default useFeedback
